import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";

export default {
    getGroups,
    getEstatesByGroupID,
    getDivisions,
    getEstateGTNFactoriesList,
    getFactoryByGroupID,
    EstateGTNFactoriesSave,
    EstateGTNFactoriesDelete
};

async function getDivisions(estateID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateId=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return array;
}
async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        
    }
    return array;
}


async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}
async function getEstateGTNFactoriesList(operationEntityID,collectionPointID) {
    var response = await CommonGet('/api/EstateGTNFactories/GetEstateGTNFactoriesList', 'operationEntityID=' + operationEntityID  + '&collectionPointID='+ collectionPointID);
    return response.data;
}
async function getFactoryByGroupID(id) {
    var factoryArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            factoryArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return factoryArray;

    
}

async function EstateGTNFactoriesSave(saveData) {
    const response = await CommonPost('/api/EstateGTNFactories/SaveEstateGTNFactories', null, saveData);
    return response;
}

async function EstateGTNFactoriesDelete(gtnFactoryMappingID) {
    const response = await CommonPost('/api/EstateGTNFactories/UpdateEstateGTNFactories', 'gtnFactoryMappingID=' + gtnFactoryMappingID);
    return response;
}
